import {
  GEO_FEATURE_MARKER_COLOR,
  HIGH_RISK_MARKER_COLOR,
  SEARCH_MARKER_COLOR,
} from '@/feature/observatory'

import { MarkerBadge } from '@/components/MarkerBadge'
import { LuBolt, LuMapPin, LuNavigation2, LuTriangleAlert } from 'react-icons/lu'

/** Keeps the pin at the legacy artwork's 54px width, whatever the caller passes. */
const AssetMarkerPin = ({ rotate, color }: { rotate?: number; color?: string }) => (
  <MarkerBadge
    glyph={LuNavigation2}
    shape="pin"
    size={54}
    color={color ?? 'currentColor'}
    rotate={rotate}
    filled
  />
)

const SearchMarkerPin = () => <LuMapPin size={33} color={SEARCH_MARKER_COLOR} />

export const ICON_MAP = {
  asset: AssetMarkerPin,
  geoFence: ({ highRiskArea }: { highRiskArea: boolean }) => (
    <div>
      {highRiskArea ? (
        <MarkerBadge glyph={LuTriangleAlert} color={HIGH_RISK_MARKER_COLOR} size={40} />
      ) : (
        <MarkerBadge glyph={LuBolt} size={40} color={GEO_FEATURE_MARKER_COLOR} />
      )}
    </div>
  ),
  custom: SearchMarkerPin,
} as const
